import type { ActivityModule } from '../../core/activity';
import { mountGnumchFactors } from './ui';
import levelsData from './levels.json';
import '../gnumch-equality/style.css';

export const gnumchFactors: ActivityModule = {
  id: 'gnumch-factors',
  title: 'Comilão de fatores',
  description: 'Guie o Comilão até os fatores do número alvo (números que dividem ele exatamente). Cuidado com os fantasmas!',
  ageMin: 8,
  ageMax: 12,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/gnumch-factors/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountGnumchFactors,
};
